import { Configuration, LogLevel } from '@azure/msal-browser';
import { getFrontendConfig } from '../config/frontendConfig';

const frontendConfig = getFrontendConfig();
const clientId = frontendConfig.entra.clientId;
const tenantId = frontendConfig.entra.tenantId;
const basePath = frontendConfig.urls.basePath;

function resolveAppPath(basePath: string, relativePath: string) {
    const normalizedBasePath = basePath === '/'
        ? '/'
        : `/${basePath.replace(/^\/+|\/+$/g, '')}/`;

    return `${normalizedBasePath}${relativePath.replace(/^\/+/, '')}`;
}

const redirectUri = resolveAppPath(basePath, '/auth/callback');

export const msalConfig: Configuration = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri,
        postLogoutRedirectUri: redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                    case LogLevel.Info:
                        // console.info(message);
                        break;
                    case LogLevel.Verbose:
                        // console.debug(message);
                        break;
                }
            },
            logLevel: LogLevel.Warning,
        },
    },
};

// Scopes matching the existing IdentityServer4 API scopes
export const apiScopes = {
    // Primary API scope - matches the existing "AnyApi" scope
    anyApi: `api://${clientId}/AnyApi`,
    // External API scope
    extApi: `api://${clientId}/ExtApi`,
};

// Login request scopes
export const loginRequest = {
    scopes: ['openid', 'profile'/*, apiScopes.anyApi*/],
};

// Token request used for the server-side exchange/bootstrap step.
export const exchangeTokenRequest = {
    scopes: [frontendConfig.entra.exchangeScope],
};
